// extracted by mini-css-extract-plugin
module.exports = {"detailViewRoot":"detailview_detailViewRoot__2uIJ-"};